import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { Types, IConsultarRelacaoUsuarioRequest } from './types';
import {
	consultarRelacaoUsuarioFailure,
	consultaRelacaoUsuarioSuccess,
} from './actions';

function* consultarRelacaoUsuario(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: IConsultarRelacaoUsuarioRequest } = request;

	// yield put(consultarRelacaoUsuarioClear());

	// const payloadQR: IConsultarRelacaoUsuarioRequest = {
	// 	idOrgao: payload.idOrgao,
	// 	idLocalidade: payload.idLocalidade,
	// };

	// if (payload?.codigoMainFrame) {
	// 	payloadQR.codigoMainFrame = payload.codigoMainFrame;
	// }

	// if (payload?.page) {
	// 	payloadQR.page = payload.page;
	// }

	// if (payload?.size) {
	// 	payloadQR.size = payload.size;
	// }

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as IConsultarRelacaoUsuarioRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`usuarios/localidades`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaRelacaoUsuarioSuccess(response));
	} else {
		yield put(consultarRelacaoUsuarioFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_RELACAO_USUARIO_REQUEST, consultarRelacaoUsuario),
]);
